"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paletteValueToRgbaArray = void 0;
var _spectrumConfigs = require("../spectrum/spectrumConfigs");
var _memoize = require("../utils/memoize");
var _paletteValueToCacheName = require("./paletteValueToCacheName");
var _paletteValueToTuple2 = require("./paletteValueToTuple");
/**
 * Given a color that is a PaletteValue and the spectrum, output a hex value of this color
 * @param color: PaletteValue - gray0, etc...
 * @param spectrum: Spectrum - dark or light
 * @returns rgbaArray - [255, 255, 255, 1]
 */
const paletteValueToRgbaArray = (0, _memoize.memoize)((paletteValue, spectrum) => {
  const _paletteValueToTuple = (0, _paletteValueToTuple2.paletteValueToTuple)(paletteValue),
    alias = _paletteValueToTuple[0],
    opacity = _paletteValueToTuple[1];
  const spectrumConfig = _spectrumConfigs.spectrumConfigs.base[spectrum];
  const _spectrumConfig$alias = spectrumConfig[alias],
    red = _spectrumConfig$alias[0],
    green = _spectrumConfig$alias[1],
    blue = _spectrumConfig$alias[2];
  return [red, green, blue, opacity];
}, _paletteValueToCacheName.paletteValueToCacheName);
exports.paletteValueToRgbaArray = paletteValueToRgbaArray;